var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-code-view" },
    [
      _vm.hasErrors
        ? [_c("h2", [_vm._v(_vm._s(_vm.$t("ticketList.error")))])]
        : [
            _c(
              "div",
              { staticClass: "ticketCode__box", attrs: { id: "ticketCode" } },
              [
                _c(
                  "div",
                  { staticClass: "input" },
                  [
                    _c("p", { staticClass: "h3 ticketCode__boxHeadline" }, [
                      _vm._v(_vm._s(_vm.$t("ticketList.ticketCode.headline"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "ticketCode__boxText",
                        attrs: { for: "" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("ticketList.ticketCode.subHeadline"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        staticClass:
                          "ticketCode__boxInput form__group form__group--input",
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.redeemCode.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim.lazy",
                              value: _vm.newUserCode,
                              expression: "newUserCode",
                              modifiers: { trim: true, lazy: true },
                            },
                          ],
                          staticClass:
                            "ticketCode__boxInputElement input input--input",
                          attrs: { id: "", type: "text" },
                          domProps: { value: _vm.newUserCode },
                          on: {
                            change: function ($event) {
                              _vm.newUserCode = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errorCode
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("errorCodes." + _vm.errorCode))),
                        ])
                      : _vm.newUserCodeError
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ticketList.ticketCode.invalidCode", {
                                invalidCode: _vm.lastUserCode,
                              })
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.codeLoading
                      ? [_c("spinner", { staticClass: "spinner--white" })]
                      : [
                          _c(
                            "button",
                            {
                              staticClass: "ticketCode__boxButton button",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.redeemCode.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("ticketList.ticketCode.redeemCode")
                                )
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "payment__images-agb__privacy" }, [
              _c(
                "div",
                { staticClass: "ticketList-agb-privacy" },
                [
                  _c(
                    "div",
                    { staticClass: "privacyStatement" },
                    [
                      _vm.eventSelection &&
                      _vm.privacyStatements["" + _vm.eventSelection.clientId]
                        ? [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "inline-link privacyStatement-link",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.openPrivacyModal()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("privacy.client.privacyStatement2")
                                    )
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "inline-link privacyStatement-link",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.i18nPrivacyStatementLink,
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("privacy.client.privacyStatement2")
                                    )
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "privacyStatement" },
                    [
                      _vm.eventSelection &&
                      _vm.agb["" + _vm.eventSelection.clientId]
                        ? [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "inline-link privacyStatement-link",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.openAGBModal()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("privacy.agb.agbOf"))
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "a",
                              {
                                staticClass: "privacyStatement-link",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.i18nTermsAndConditionsLink,
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("privacy.agb.agbOf"))
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "Modal",
                    { ref: "privacyModal" },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _vm.selectedPrivacyStatement
                            ? [
                                _c("div", {
                                  staticClass: "privacyModal",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.i18nPrivacyStatementContent
                                    ),
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "Modal",
                    { ref: "agbModal" },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _vm.selectedAGB
                            ? [
                                _c("div", {
                                  staticClass: "privacyModal",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.i18nTermsAndConditionsContent
                                    ),
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }